import React from 'react';
import { motion } from 'framer-motion';
import VideoBackground from './VideoBackground';

export default function Hero() {
  const scrollToContact = () => {
    document.getElementById('contact-section')?.scrollIntoView({ behavior: 'smooth' });
  };

  const heroVideo = "https://ik.imagekit.io/aeu02xvjgn/Summer%20Promotion/0606%20(1).mov";
  const heroPoster = "https://ik.imagekit.io/aeu02xvjgn/Summer%20Promotion/Summer%20Hero%20Banner.png";

  return (
    <section className="relative h-[100svh] w-full flex flex-col justify-end md:justify-center overflow-hidden">
      {/* Background Layer: z-0 & z-10 */}
      <VideoBackground 
        src={heroVideo} 
        poster={heroPoster}
        overlayOpacity="bg-gradient-to-t from-black/90 via-black/20 to-black/10 md:bg-black/30"
        videoPosition="object-center"
      />

      {/* Content Layer: z-20 */}
      <div className="relative z-20 max-w-7xl mx-auto px-6 w-full pb-12 md:pb-0">
        <div className="max-w-3xl text-center md:text-left">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1.2, ease: "easeOut" }}
          >
            <span className="block text-gold-light text-[10px] md:text-sm uppercase tracking-[0.4em] mb-4 font-bold md:font-medium">
              A Limited Seasonal Opportunity
            </span>
            
            <h1 className="text-[40px] leading-[1.1] md:text-7xl lg:text-8xl text-ivory mb-4 md:mb-6 font-serif">
              Special <span className="text-gold">Summer</span> <br className="hidden md:block" /> Wedding Promotion
            </h1>

            <h2 className="text-lg md:text-2xl font-sans font-light tracking-wide mb-6 md:mb-8 text-ivory/90">
              Select July & August Dates Available
            </h2>

            {/* Mobile Only Short Line */}
            <p className="md:hidden text-[13px] uppercase tracking-[0.1em] text-ivory/70 mb-10 leading-relaxed font-medium max-w-xs mx-auto">
              Shaded ceremony spaces. <br/> Indoor reception comfort. <br/> A romantic hillside estate.
            </p>

            {/* Desktop Only Long Line */}
            <p className="hidden md:block text-lg font-light max-w-xl mb-12 leading-relaxed text-ivory/90">
              Celebrate your summer wedding at a romantic hillside estate with shaded ceremony spaces, mature trees, and <span className="text-white font-normal underline decoration-gold/40 underline-offset-4">indoor reception comfort</span>.
            </p>

            {/* Stacked Buttons on Mobile */}
            <div className="flex flex-col sm:flex-row items-center justify-center md:justify-start gap-4">
              <button 
                onClick={scrollToContact}
                className="bg-gold hover:bg-gold-dark text-white px-10 py-5 uppercase tracking-widest text-[11px] font-bold transition-all duration-500 w-full sm:w-auto"
              >
                Schedule Your Private Tour
              </button>
              <button 
                onClick={scrollToContact}
                className="bg-transparent border border-ivory/40 hover:border-ivory hover:bg-white/5 text-white px-10 py-5 uppercase tracking-widest text-[11px] font-bold transition-all duration-500 w-full sm:w-auto backdrop-blur-sm"
              >
                Ask About Available Dates
              </button>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}